import React from "react";
import pic1 from "../../../images/galleryimage/pic1.jpeg"
const GallerySection2 = () => {
  return (
    <>
      <div className="mt-32 flex-row-reverse  items-center justify-evenly text-justify lg:flex lg:mt-44 overflow-hidden ">
        <div className="lg:w-[50%]">
          <img
            className="lg:w-full rounded-xl mx-auto w-[90%] "
            src={pic1}
            alt=""
          />
        </div>
        <div className="bg-white pb-10 lg:w-[40%] ">
          <div className="mx-5">
            <h1 className="mt-5 text-4xl font-bold ">IMPORTANCE </h1>
            <p className="mt-8 text-2xl font-medium leading-8 lg:px-20">
              Festivals are a great way to understand one's culture. A child can
              be taught more about their culture and their country during
              festivals and celebrations. This teaches them about their roots in
              the world and makes them proud of their country and culture.
            </p>
            <h2 className="mt-20 text-xl  text-gray-700 lg:px-20 ">
              <ul className="list-disc mx-6  ">
                <li>
                  Kids will have better memory about a festival when they learn
                  about its glory in a fun manner.{" "}
                </li>
                <li>
                  {" "}
                  Festivals are integral to building cultural habits and growing
                  with good ethics.
                </li>
                <li>
                  {" "}
                  Students learn to understand various customs and practices of
                  other religions.
                </li>
              </ul>
            </h2>
          </div>
        </div>
      </div>
    </>
  );
};

export default GallerySection2;
